function download_manual() {
    var u = get_current_user();
    var file = 'Handleiding_VCP-O.pdf';
    if(this_user_has_roles([
        'Student',
        'Teacher',
        'Supervisor'
    ])) {
        file = 'Handleiding Portal VCP-O.pdf';
    }
    window.location.assign('https://visualsystems.nl/handleidingen/'+file); return false;
}
